import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocationBypassService {

  // List of email domains that should bypass location check
  private readonly bypassDomains = [
    '@dtv.com',
    '@directv.com',
    '@demo.com',
    '@test.com',
    '@DTVDirectvSales.com'
  ];

  // List of specific emails that should bypass location check
  private readonly bypassEmails = [
    'dtvcomm.demo@demo.com',
    'auto.login.qa@directv.com',
    'comm.demo@demo.com'
  ];

  /**
   * Check if the given email should bypass the location request
   * @param email The email address to check
   * @returns true if location check should be bypassed, false otherwise
   */
  shouldBypassLocation(email: string): boolean {
    if (!email) {
      return false;
    }

    const emailLower = email.toLowerCase().trim();

    // Check if exact email match
    if (this.bypassEmails.some(bypassEmail => bypassEmail.toLowerCase() === emailLower)) {
      return true;
    }

    // Check if domain matches
    return this.bypassDomains.some(domain => emailLower.endsWith(domain.toLowerCase()));
  }
}
